import React, { PureComponent } from 'react';
import { FiX } from 'react-icons/fi';
import { Translate, withLocalize } from 'react-localize-redux';
import Sidebar from 'react-sidebar';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import styled from 'styled-components';

import Game from './game';
import Item from './item';
import jaLocale from './ja.locale';

/**
 * Container
 */
const Header = styled.div`
  background: black;
  display: flex;
  height: 3.5rem;
  grid-area: navbar;
  align-items: center;
  padding: 0 1em;
  flex-shrink: 0;
  border-bottom: 0.05em rgba(255, 255, 255, 0.9) solid;
  cursor: pointer;
`;

/**
 * Flex component used to push elements left and right
 */
const Spacer = styled.div`
  flex: 1;
`;

const ItemWrapper = styled.div`
  overflow: auto;
  background: rgba(0, 0, 0, 0.8);
  flex: 1 0 auto;
`;

const ItemHeader = styled.div`
  padding: 0.5em 0.5em 0.5em 2em;
  background: #ebedef;
  color: black;

  @media (min-width: 768px) {
    font-size: 0.8em;
  }
`;

const ItemDivider = styled.div`
  height: 0.1em;
  background: #ebedef;
`;

const games = {
  game0: '/games/2/',
  game1: '/games/1/',
  game3: '/games/3/',
  game6: '/games/6/'
};

const userInfos = {
  orders: '/account/orders/',
  payment: '/account/payment/',
  profile: '/account/profile/'
};

const links = {
  faq: '/faq/',
  contact: '/contact/'
};

/**
 * Menu component
 * Provides ability to navigate
 */
class Menu extends PureComponent {
  state = {
    fullWidth: false
  };
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }

  componentDidMount() {
    this.setState({
      fullWidth: window.innerWidth < 768
    });
  }

  /**
   * Menu Item Click Callback
   * Close the menu, and then send the url of the menu item clicked to GTM
   */
  closeMenu = event => {
    this.props.onSetRequest(false);
    const url = event.currentTarget.dataset.to;
    if (url) {
      window.dataLayer.push({
        event: 'MENU_ITEM_CLICKED',
        url
      });
    }
  };

  getSidebarContent = () => {
    const authOption = this.props.authenticated ? 'logout' : 'login';
    return (
      <>
        <Header onClick={this.closeMenu}>
          <Spacer />
          <FiX size="2em" />
        </Header>
        <ItemWrapper>
          <ItemHeader>
            <Translate id="menu.header.games" />
          </ItemHeader>
          {Object.keys(games).map(name => (
            <Game
              data-to={games[name]}
              key={name}
              name={name}
              onClick={this.closeMenu}
              to={games[name]}
            />
          ))}
          <ItemDivider />
          <Item
            data-to="/history/"
            name="history"
            onClick={this.closeMenu}
            to="/history/"
          />
          <ItemHeader>
            <Translate id="menu.header.userInfo" />
          </ItemHeader>
          {Object.keys(userInfos).map(name => (
            <Item
              data-to={userInfos[name]}
              indented={1}
              key={name}
              name={name}
              onClick={this.closeMenu}
              to={userInfos[name]}
            />
          ))}
          <ItemDivider />
          {Object.keys(links).map(name => (
            <Item
              data-to={links[name]}
              key={name}
              name={name}
              onClick={this.closeMenu}
              to={links[name]}
            />
          ))}
          {this.props.authLoaded && (
            <Item
              data-to={authOption}
              name={authOption}
              onClick={this.closeMenu}
              to={this.props.authenticated ? '/logout/' : '/login/'}
            />
          )}
        </ItemWrapper>
      </>
    );
  };

  render() {
    return (
      <Sidebar
        contentId="content"
        onSetOpen={this.props.onSetRequest}
        open={this.props.open}
        sidebar={this.getSidebarContent()}
        styles={{
          content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 0
          },
          sidebar: {
            zIndex: 5,
            bottom: 0,
            height: '100%',
            width: this.state.fullWidth ? '100%' : '25em',
            display: 'flex',
            flexDirection: 'column'
          },
          overlay: {
            zIndex: 4,
            backgroundColor: 'rgba(0,0,0,.6)'
          },
          dragHandle: {
            zIndex: 4
          }
        }}
      >
        {this.props.children}
      </Sidebar>
    );
  }
}

Menu.propTypes = {
  authLoaded: PropTypes.bool.isRequired,
  authenticated: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onSetRequest: PropTypes.func.isRequired
};

export default compose(withLocalize)(Menu);
